import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getBarChart = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.BARCHART, {
      withCredentials: true,
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getPieChart = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.PIECHART, {
      withCredentials: true,
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAnalyticsData = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ANALYTICSDATA,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyCounts = async (last24Hours = false) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.STUDYCOUNTS,
      {
          last24Hours: last24Hours, // Add the flag to the request body
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getOnlineRadiologist = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      SERVICEURL + APIs.GETONLINERADIOLOGIST,
      {
        withCredentials: true,
        data:{
          firmId:firmId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getOnlineQcSupervisor = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      SERVICEURL + APIs.GETONLINEQCSUPERVISOR,
      {
        withCredentials: true,
        data:{
          firmId:firmId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const forceLogout = async (username,unassignStudies) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "auth/forceLogout",
      {
        withCredentials: true,
        data: {
          forceLogoutDto: {
            username: username,
            unassignStudies: unassignStudies
          },
        },
      }
    );
    return response;
  } catch (error) {
    // 403 with errorCode "009" is a deliberate authorization denial from the backend, not an
    // expired session - surface it to the caller instead of logging the admin out.
    const isAuthorizationDenial = error.response?.data?.errorCode === "009";
    if (error.response?.status === 403 && !isAuthorizationDenial)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
// export const getStudyDrilldownData = async (dateStr) => {
//   try {
//     const response = await axiosInterceptor.get(
//       API_BASE_URL + `jwtServices/charts/drilldown/day?selectedDate=${dateStr}`,
//       {
//         withCredentials: true,
//       }
//     );
//     return response;
//   } catch (error) {
//     if (error.response?.status === 403) {
//       window.location.assign(APIs.REDIRECTLOGOUT);
//     } else return error.response;
//   }
// };
export const getStudyDrilldownData = async (selectedDate, chartConfigDto, hospitalIdsMappedToCurrentUser, userIds) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + `jwtServices/charts/drilldown/day`,
      {
        selectedDate,
        chartConfigDto,
        hospitalIdsMappedToCurrentUser,
        userIds
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else return error.response;
  }
};


